export default "__VITE_ASSET__h0VN56C0__"